export default __webpack_public_path__ + "assets/food-truck.0b9c8dca.svg";